/**
 * A betta Program and Conference management solution
 *
 * @package:  Betta
 * @version:  2.2
 * @author:   Cyrill N KALITA
 */

/**
 * Polifyll to support IE
 */
import "babel-polyfill";

/**
 * First we will load all of this project's JavaScript dependencies
 */
require('./bootstrap');

/**
 * Next, we will create a fresh Angular application instance
 * and inject all requires modules
 */
const app = angular.module('App', [
    'flsControllers',
    'flsServices',
    'checklist-model',
    'angular-loading-bar',
    'ngAnimate',
]);

/**
 * Finally, configure Angular app
 *
 * @param  {Object} $httpProvider
 * @return void
 */
app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common = {
        'X-CSRF-TOKEN': Laravel.csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
      };
}]);


/**
 * Configure Angular app Progress bar
 *
 * @param  {Object} $cfpLoadingBarProvider
 * @return void
 */
app.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
    // Turn off spinner
    cfpLoadingBarProvider.includeSpinner = false;
}]);
